import {Container} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";

export class SwivuLinkText extends Container {
  static get type() {
    return WIDGET_KEYS.swivuLinkText;
  }

  static get configurable() {
    return {
      cls: "flex-row",
      items: {
        linkText: {
          type: "label",
          cls: "b-inline py-4"
        },
        linkButton: {
          type: "button",
          contentElementCls: "link-blue-text",
          cls: "b-inline b-transparent pl-1"
        }
      }
    }
  }
}

SwivuLinkText.initClass();